import React, { createContext, useContext, useReducer, useEffect } from 'react';
// Actions
import { types as ctaLogTypes } from '../actions/ctalogs';
// Utils
import { sortList } from '../utils/Sort';

const CTALogTypesContext = createContext();

const initialState = {
  data: [],
  sort: {
    type: null,
    accessor: null,
  },
  loading: true,
  reload: false,
};

const dataReducer = (state, action) => {
  switch (action.type) {
    case 'SET_DATA':
      return { ...state, data: action.payload, loading: false };
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_SORT':
      return { ...state, sort: action.payload };
    case 'SET_RELOAD':
      return { ...state, reload: action.payload };
    default:
      return state;
  }
};

export const CTALogTypesDataProvider = ({ children }) => {
  // useReducer
  const [state, dispatch] = useReducer(dataReducer, initialState);

  useEffect(() => {
    const fetchTypesData = async () => {
      await ctaLogTypes({
        success: (data) => {
          handleSorting(data);
        },
        error: (error) => {
          throw new Error('Failed to fetch data');
        },
      });
    };

    fetchTypesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.reload]);

  useEffect(() => {
    handleSorting(state.data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.sort]);

  // Methods
  const handleSorting = (data) => {
    if (state.sort.accessor && state.sort.type) {
      const sortedList = sortList(data, state.sort.accessor, state.sort.type);

      dispatch({ type: 'SET_DATA', payload: sortedList.data });
    } else {
      dispatch({ type: 'SET_DATA', payload: data });
    }
  };

  return <CTALogTypesContext.Provider value={{ state, dispatch }}>{children}</CTALogTypesContext.Provider>;
};

export const useCTALogTypesData = () => {
  const context = useContext(CTALogTypesContext);
  if (!context) {
    throw new Error('useCTALogTypesData must be used within a CTALogTypesDataProvider');
  }
  return context;
};
